/**
 * Build CheckoutSessionDisplayLine rows for SA phone review.
 * Prefer enriched `displayLines` from session GET; else map shop lines + product names.
 */
import type { CheckoutSessionDisplayLine } from 'pi-kiosk-shared';

export interface SellerAssistedShopLineInput {
  readonly productId: number;
  readonly quantity: number;
  readonly unitPrice: number;
  readonly lineTotal: number;
}

export interface SellerAssistedProductNameSource {
  readonly id: number;
  readonly name?: string | null;
}

export function resolveSellerAssistedDisplayLines(input: {
  readonly displayLines?: readonly CheckoutSessionDisplayLine[] | null;
  readonly lines?: readonly SellerAssistedShopLineInput[] | null;
  readonly products?: readonly SellerAssistedProductNameSource[] | null;
}): readonly CheckoutSessionDisplayLine[] {
  const enriched = input.displayLines;
  if (enriched != null && enriched.length > 0) {
    return enriched.map((line) => ({
      name: line.name.trim().length > 0 ? line.name.trim() : '—',
      quantity: line.quantity,
      unitPrice: line.unitPrice,
      lineTotal: line.lineTotal,
    }));
  }

  const lines = input.lines ?? [];
  if (lines.length === 0) {
    return [];
  }

  const nameById = new Map<number, string>();
  for (const product of input.products ?? []) {
    const name = product.name?.trim() ?? '';
    if (name.length > 0) {
      nameById.set(product.id, name);
    }
  }

  return lines.map((line) => ({
    name: nameById.get(line.productId) ?? `#${line.productId}`,
    quantity: line.quantity,
    unitPrice: line.unitPrice,
    lineTotal: line.lineTotal,
  }));
}
